import { createStore, applyMiddleware, combineReducers } from "redux";
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from "redux-devtools-extension";
import { AuthReducer } from "../features/Auth/reducers";
import { SearchReducer } from "../features/Search/reducer";
import { UploadReducer } from "../features/Upload/reducer";
import UtilReducer from "../features/Dialog/reducer";
import { AccessMediatorReducer } from "../features/AccessMediator/reducer";
import { SubscriptionReducer } from "../features/Subscriptions/reducer";

const rootReducer = combineReducers({
    util: UtilReducer,
    auth: AuthReducer,
    search: SearchReducer,
    accessMediator: AccessMediatorReducer,
    // log: LogReducer,
    // logRules: LogRulesReducer,
    upload: UploadReducer,
    subscription:SubscriptionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default function store() {
    const middlewares = [thunkMiddleware];
    const middleWareEnhancer = applyMiddleware(...middlewares);

    const store = createStore(
        rootReducer,
        composeWithDevTools(middleWareEnhancer)
    );

    return store;
}